const getCookie = (name) => {
  let cookieArr = document.cookie.split(";")
  for (let i=0; i<cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");
    if (name === cookiePair[0].trim()){
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return '';
}

const fetchNaverPayInfo = async (cart, backUrl, customerId) => {
  const url = 'https://allbirds.lukuku.co/payment/product-info'
  const nvadid = getCookie('NVADID')
  const cpavalidator = getCookie('CPAValidator')
  const naco = getCookie('NA_CO')

  const payload = { 
    cart,
    backUrl,
    customerId,
    nvadid,
    cpavalidator,
    naco,
  }
  
  return fetch(url, {
    method: 'POST',
    headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(response => response.json()) 
  .then(data => {
    if (data.status == 'success') {
      const paymentUrl = data.paymentUrl;
      const orderId = data.orderId;
      const shopId = data.shopId;
      const totalPrice = data.totalPrice;
      const requestUrl = `${paymentUrl}?ORDER_ID=${orderId}&SHOP_ID=${shopId}&TOTAL_PRICE=${totalPrice}&BACK_URL=${backUrl}`;
      window.location.href= requestUrl;
    }
  })
}

const pdp_buy_nc = () => {
  const baseUrl = window.location.origin + window.location.pathname;
  const customerId = window.customerId
  const variantId = document.querySelector('[data-variant-id]').value;
  const quantity = document.querySelector('[data-quantity]').value

  const productsJsonEl = document.querySelector('[data-products-json]');
  if (productsJsonEl) {
    const productsJson = JSON.parse(productsJsonEl.textContent || '{}');
    const variants = Array.isArray(productsJson.variants) ? productsJson.variants : [];
    const currentVariant = variants.find(v => Number(v.id) === Number(variantId));
    if (currentVariant) {
      const productAvailable = !!currentVariant.available;
      const productInventoryManagement = currentVariant.inventory_management;
      const productInventoryPolicy = currentVariant.inventory_policy;
      const productQuantityMin = (currentVariant.quantity_rule && currentVariant.quantity_rule.min) ? currentVariant.quantity_rule.min : 1;
      const productQuantity = Number(currentVariant.inventory_quantity);

      let check_against_inventory = true;
      let quantity_rule_soldout = false;
      if (productInventoryManagement !== 'shopify' || productInventoryPolicy === 'continue') check_against_inventory = false;
      if ((Number(productQuantityMin) > Number(productQuantity)) && check_against_inventory) quantity_rule_soldout = true;

      const unavailable = productAvailable === false || quantity_rule_soldout;
      if (unavailable) {
        alert('품절된 옵션은 구매할 수 없습니다.');
        return;
      }
    }
  }

  const payload = [{
    productVariantId: variantId,
    quantity: quantity
  }]

  fetchNaverPayInfo(payload, baseUrl, customerId);
}

const cart_buy_nc = async () => {
  const baseUrl = window.location.origin + window.location.pathname;
  const customerId = window.customerId;

  const payload = await fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then((res) => {
    return res.items.map((item) => {
      return {
        productVariantId: item.variant_id,
        quantity: item.quantity,
      }
    })
  })
  .catch((err) => console.log('Error: ', err));
  fetchNaverPayInfo(payload, baseUrl, customerId);
}

const not_buy_nc = () => {
  alert("구매할 수 없습니다.");
  return;
}
const wishlist_nc = () => {
  console.log("wishlist!")
  return;
}